<template>
  <GameLayout
    class="cards-game"
    :score="score"
    :class="{
      'success lighten-4': (showWrongAnswer && currentCard.answer),
      'error lighten-3': (showWrongAnswer && !currentCard.answer),
      'success lighten-4': gameOver,
    }"
    @close="$track('game_leave', 'cards')"
  >
    <!-- Loading screen -->
    <BaseLoader v-if="loading" />

<!--     <div class="justify-center text-center pt-4 d-none">
      <GameTimer
        ref="GameTimer"
        :time="this.gameTime"
        @end="timeEnd()"
      />
    </div> -->

    <div
      class="card-container d-flex justify-center"
      :class="{ 'wrong-answer': showWrongAnswer }"
    >
      <CardsGameOver v-if="gameOver" />

      <CardsSwiper
        v-else-if="!showWrongAnswer"
        :cards="cards"
        @nope="nope()"
        @yes="yes()"
      />
      <CardsGameCard
        v-else
        :title="$localized(currentCard, 'question')"
        :pic="currentCard.pic"
        class="game-card elevation-2 mb-12"
      />
    </div>

    <CardsButtons
      class="fixed-bar"
      v-if="!$store.state.cards.loading && !gameOver"
      @nope="nope()"
      @yes="yes()"
    />

      <!-- v-if="showWrongAnswer" -->
      <!-- v-if="false" -->
    <CardsErrorFalse
      v-if="showWrongAnswer && !currentCard.answer"
      :title="$localized(currentCard, 'question')"
      :explanation="$localized(currentCard, 'explanation')"
      :source="currentCard.source"
      @resume="resume()"
    />
    <CardsErrorTrue
      v-if="showWrongAnswer && currentCard.answer"
      :title="$localized(currentCard, 'title')"
      :explanation="$localized(currentCard, 'explanation')"
      :source="currentCard.source"
      @resume="resume()"
    />

    <CardsCreateTeams
      v-if="isClassModeCreator"
      v-model="classTeamsModal"
    />
    <CardsTeamSelect
      v-else
      v-model="classTeamsModal"
    />
  </GameLayout>
</template>

<style scoped lang="scss">
.cards-game {
  background: $grey-bg;
}
</style>
<style scoped>
  .cards-game >>> .v-main__wrap{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

.card-container {
  height: 50vh;
  margin: 32px auto;
  position: relative;
  width: 80vw;
}

.fixed-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
}

@media screen and (max-width: 600px) {
  .card-container.wrong-answer {
    height: 110vh;
  }
}

/* ToDo @CodingCarlos: On button press, animate position; */
</style>

<script>
import GameLayout from '@/layouts/GameLayout.vue';

import CardsButtons from '@/components/games/cards/CardsButtons.vue';
import CardsCreateTeams from '@/components/games/cards/CardsCreateTeams.vue';
import CardsErrorFalse from '@/components/games/cards/CardsErrorFalse.vue';
import CardsErrorTrue from '@/components/games/cards/CardsErrorTrue.vue';
import CardsGameOver from '@/components/games/cards/CardsGameOver.vue';
import CardsGameCard from '@/components/games/cards/CardsGameCard.vue';
import CardsSwiper from '@/components/games/cards/CardsSwiper.vue';
import CardsTeamSelect from '@/components/games/cards/CardsTeamSelect.vue';
// import GameTimer from '@/components/games/GameTimer.vue';

// Scoring variables
const CORRECT_SCORE = 10;
// const CLUE_PENALTY = 5;

export default {
  name: 'Cards',
  components: {
    GameLayout,
    CardsButtons,
    CardsCreateTeams,
    CardsErrorFalse,
    CardsErrorTrue,
    CardsGameOver,
    CardsGameCard,
    CardsSwiper,
    CardsTeamSelect,
    // GameTimer,
  },
  data: () => ({
    gameTime: 6000,
    // cards: [],
    showWrongAnswer: false,
    polling: null,
  }),
  computed: {
    loading() {
      return this.$store.state.cards.loading;
    },
    cards() {
      return this.$store.state.cards.list || [];
    },
    gameOver() {
      const over = this.cards.length === 0 && !this.$store.state.cards.loading;

      // if (over) {
      //   this.$refs.GameTimer.stop();
      // }

      return over;
    },
    score() {
      if (this.isClassMode) {
        return this.$store.getters['classMode/score']('cards');
      }

      return this.gameOver ? ' ' : this.$store.getters['cards/score'];
    },
    currentCard() {
      return this.cards[this.cards.length - 1] || {};
    },
    classTeamsModal() {
      let teamSelected = this.$store.state.classMode.cardsTeam > 0;

      // For teacher, check if team count is set
      if (this.isClassModeCreator) {
        teamSelected = this.$store.state.classMode.cardsTeams > 0;
      }

      return this.isClassMode && !teamSelected;
    },
  },
  methods: {
    yes() {
      if (this.currentCard.answer) {
        return this.correctAnswer();
      }

      return this.wrongAnswer();
    },
    nope() {
      if (!this.currentCard.answer) {
        return this.correctAnswer();
      }

      return this.wrongAnswer();
    },

    correctAnswer() {
      this.$store.dispatch('cards/answer', {
        id: this.currentCard.id,
        success: true,
        points: CORRECT_SCORE,
        classMode: this.isClassMode,
      });

      this.$store.dispatch('alerts/show', {
        text: this.$t('GAME.CARDS.CORRECT'),
        color: 'success',
      });

      this.$store.dispatch('cards/pop');
      this.$track('game_success', 'cards');
    },
    wrongAnswer() {
      // this.$refs.GameTimer.stop();
      this.$store.dispatch('cards/answer', {
        id: this.currentCard.id,
        success: false,
        points: 0,
        classMode: this.isClassMode,
      });
      this.showWrongAnswer = true;
      this.$track('game_error', 'cards');
    },

    resume() {
      // this.$refs.GameTimer.start();
      this.$store.dispatch('cards/pop');
      this.showWrongAnswer = false;
    },

    timeEnd() {
      this.$store.dispatch('alerts/show', {
        text: this.$t('GAME.CARDS.TIMEOUT'),
      });
      this.cards = [];
    },
    startPolling() {
      this.polling = setInterval(() => {
        this.$store.dispatch('cards/get', {
          classMode: this.$store.state.classMode.session,
          polling: true,
        });
      }, 5000);
    },
  },
  created() {
    // this.$store.dispatch('score/set', 0);
    const emptyStore = this.cards.length === 0;
    if (emptyStore || this.gameOver || this.isClassMode) {
      let ops = {};
      if (this.isClassMode) {
        ops = { classMode: this.$store.state.classMode.session };
        this.startPolling();
      }
      this.$store.dispatch('cards/get', ops);
    }

    // On first play, show tutorial
    const showTutorial = !this.$store.state.settings.preEvaluatedTinder;

    if (!this.isClassMode && showTutorial) {
      this.$router.replace({ name: 'cardsTutorial' });
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>
